import { Link } from "react-router-dom";
import "./AdminNav.scss";

const AdminNav = () => {
  return (
    <div className="AdminNav">
      <nav className="admin-nav-menu">
        <ul>
          <li>
            <Link to="/admin/dashboard">Admin</Link>
          </li>
          <li>
            <Link to="/social-posting">Social Posting</Link>
          </li>
          <li>
            <Link to="/class-schedule">Class Schedule</Link>
          </li>
          <li>
            <Link to="/feedback-testimonial">Feedback & Testimonial</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default AdminNav;
